import React,{ useState,useEffect } from "react";
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Popover,
    Card,
    Table,
    TableRow,
    TableHead,
    MenuItem,
    TableBody,
    TableCell,
    TableContainer,
    TablePagination,
    Button,
    Container, 
    Stack, 
    Typography, 
    Modal, 
    TextField, 
    InputAdornment, 
    IconButton, 
    Divider, 
    Snackbar,
    Toolbar,
    OutlinedInput,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { supabaseClient } from 'src/supabase';
import { useNavigate} from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { saveAs } from 'file-saver';
import { toCanvas } from "qrcode";
import jsPDF from 'jspdf';

//----------------------------------------------------------------------
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
    height: 96,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1, 0, 3),
  }));
  
const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: "100%",
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: "100%",
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));
  
// ----------------------------------------------------------------------


export default function QRCode (){
    const navigate = useNavigate();
    const [open, setOpen] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [name,setName] = useState('');
    const [addresse,setAddresse] = useState('');
    const [contact,setContact] = useState('');
    const [password,setPassword] = useState('');
    const [passwordConf,setPasswordConf] = useState('');
    const [companies,setCompanies] = useState([]);

    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    const [openBar, setOpenBar] = useState(false);
    const [alertMessage,setAlertMessage] = useState('');

    const handleOpenBar = (message)=>{
        setAlertMessage(message)
        setOpenBar(true)
    }

    const handleCloseBar = (event, reason) => {
      setOpenBar(false);
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleAdd = async () => {
        await supabaseClient.from('Collections').insert({name})
        const {data} = await supabaseClient.from("Collections").select("*").order('created_at',{ascending:false})
        console.log("Comp",data)
        setCompanies(data)
        handleClose()
        handleOpenBar(`Une Gamme a été ajouté: ${name}.`)
        setPassword('')
        setName('')
        setPasswordConf('')
        
    };

    const [nbrPinColl,setNbrPinColl] = useState(0)
    const handleNameChange = async (input)=>{
        let stripedName = input.trim()
        if(stripedName.length > 2){
            const {data,error} = await supabaseClient.from("Produits").select("*").ilike("reference",`%${stripedName}%`)
            setName(stripedName)
            setNbrPinColl(data.length)

        }
        
    }

    useEffect(()=>{
        const fn = async ()=>{
            const resp = await supabaseClient.auth.getSession()
            console.log(resp)
            if (resp.data.session === null){
                navigate("/login",{replace:true})
            }
            const {data:access,error:er} = await supabaseClient.from("Admins").select("*")
            if (access.length === 0 || er){
                navigate('/403',{replace:true})
                console.log("Access",access)
                
            }
            const {data,error} = await supabaseClient.from("Collections").select("*").order('created_at',{ascending:false})
            console.error(error)
            console.log(data)
            setCompanies(data)
        }
        fn()
    },[])

    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - companies.length) : 0;
    const [currentID,setCurrentID] = useState('');
    const [associatedAccount,setAssociatedAccount] = useState('')
    const [serachName,setSerachName] = useState('')
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const handleOpenDelete = () => setOpenModalDelete(true);
    const handleCloseDelete = () => setOpenModalDelete(false);

    const handleFilterByName = (event) => {
        setSerachName(event.target.value)
    };

    const handleSearch = async ()=>{
        if(serachName.length > 0){
            console.log("searchTerm",serachName)
            const {data,error} = await supabaseClient.from("Collections").select("*").ilike('name',`%${serachName}%`).order('created_at',{ascending:false})
            console.log('Search',data)
            console.log('Search Error',error)
            setCompanies(data)
        }
        setPage(0);
    }

    const handleOpenMenu = (event,id) => {
        setCurrentID(id)
        setOpen(event.currentTarget);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleDelete = async ()=>{
        await supabaseClient.from("Collections").delete().eq('id',currentID)
        const {data,error} = await supabaseClient.from("Collections").select("*").order('created_at',{ascending:false})
        handleCloseMenu()
        handleCloseDelete()
        setCompanies(data)
        console.log({data,error})
        handleOpenBar(`La Gammes a bien été supprimer.`)
    }

    const qrRef = React.useRef(null);

    const generateQR = async (id,pdfName)=>{
        await toCanvas(qrRef.current, id,{scale:6});
        //const canvas = await html2canvas(qrRef.current);
        
        // Get the image data
        const imgData = qrRef.current.toDataURL('image/png');//canvas.toDataURL('image/png');
        //ImageDataURI.outputFile(imgData,`${pdfName}_QR.pdf`)
        //saveAs(imgData,`${pdfName}_QR.png`)
        // Create a new PDF
        const pdf = new jsPDF();
        
        // Add the image to the PDF
        pdf.setLineWidth(2)
        pdf.rect(5,5,80,90)
        pdf.addImage(imgData, 'PNG', 15, 10);
        pdf.text(`Gamme : ${pdfName}`,22,80)
        // Save the PDF
        pdf.save(`${pdfName}_QR.pdf`);
    
    }

    const generateQRpng = async (id,pdfName)=>{
        await toCanvas(qrRef.current, id,{scale:6});
        //const canvas = await html2canvas(qrRef.current);
        
        // Get the image data
        const imgData = qrRef.current.toDataURL('image/png');//canvas.toDataURL('image/png');
        //ImageDataURI.outputFile(imgData,`${pdfName}_QR.pdf`)
        saveAs(imgData,`${pdfName}_QR.png`)
    }

    const handleClearSearch = async ()=>{
        const {data,error} = await supabaseClient.from("Collections").select("*").order('created_at',{ascending:false})
        console.error(error)
        console.log(data)
        setCompanies(data)
    }
    
    return (
        <>
        <Helmet>
            <title> Vos Gammes </title>
        </Helmet>
        <div style={{ display: "none" }}>
            <canvas ref={qrRef} />
        </div>
        <Snackbar open={openBar} anchorOrigin={{ vertical:"top", horizontal:'center' }} autoHideDuration={6000} onClose={handleCloseBar} onClick={handleClose}>
            <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                {alertMessage}
            </Alert>
        </Snackbar>
        <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{alignItems:"center",justifyContent:'center'}}
        >
            <Container 
                sx={{
                    alignSelf:'center',
                    borderColor:'#103996',
                    borderRadius:"10px",
                    backgroundColor:'#fff',
                    padding:5,
                    justifySelf:'center',
                    marginTop:"5%"}}
            >
                <Scrollbar >
                <Stack direction="column" alignItems="center" justifyContent="space-evenly" alignContent='center' m={1} spacing={2}>
                    <Typography variant="h6"  alignContent='center'>
                        Nouvelle Gamme
                    </Typography>
                    <Divider sx={{ borderStyle: 'dashed' }} />
                    <TextField sx={{width:'50%',minWidth:250}}  name="name" label="Nom de la Gamme" onChange={(e)=>setName(e.target.value)}/>
                    
                    
                    
                    <Button 
                        variant="contained" 
                        onClick={handleAdd} 
                        mt={4} 
                        disabled={(name.length === 0) }
                    >
                    Ajouter La Gamme 
                    </Button>
                </Stack>
                </Scrollbar>
            </Container>
        </Modal>
        <Modal
            open={openModalDelete}
            onClose={handleCloseDelete}
            sx={{alignItems:"center",justifyContent:'center'}}
        >
            <Container 
                sx={{
                    alignSelf:'center',
                    borderColor:'#103996',
                    borderRadius:"10px",
                    backgroundColor:'#fff',
                    padding:5,
                    justifySelf:'center',
                    marginTop:"5%"}}
            >
                <Scrollbar >
                <Stack direction="column" alignItems="center" justifyContent="space-evenly" alignContent='center' m={3} spacing={3}>
                    <Typography variant="h6"  alignContent='center' textOverflow='revert'>
                        Voulez Vous Supprimer cette Gamme ?
                    </Typography>
                    
                    <Divider sx={{ borderStyle: 'dashed' }} />
                    <Typography variant="h8" alignContent='center' color="text.secondary" textAlign='center'>
                    <strong> Veuillez noter que les informations associées seront perdu et irrecuperable !</strong>
                    </Typography>
                    <Stack direction="row" alignItems="center" justifyContent="space-evenly" alignContent='center' m={3} spacing={3}>
                        <Button
                            variant="contained"
                            startIcon={<DeleteForeverIcon />}
                            onClick={handleDelete}
                        >
                            OUI 
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleCloseDelete}
                        >
                            NON
                        </Button>
                    </Stack>
                </Stack>
                </Scrollbar>
            </Container>
        </Modal>
        <Container>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
                Gammes
            </Typography>
            <Button variant="contained" onClick={handleOpen} startIcon={<Iconify icon="eva:plus-fill" />}>
                Nouvelle Gamme
            </Button>
            </Stack>

            <Card>
            <StyledRoot>
                
                <Stack direction="row" width='100%' alignItems="center" justifyContent="space-between" >
                    <StyledSearch
                        onChange={handleFilterByName}
                        placeholder="Rechercher Un Produit"
                    />
                    <IconButton variant="contained" onClick={handleSearch} sx={{height:'100%',marginLeft:5,marginRight:5}} >
                        <Iconify icon="eva:search-fill" sx={{ width: 50, height: '100%' }} />
                    </IconButton>
                    <Button variant="contained" onClick={handleClearSearch} >
                        Effacer recherche
                    </Button>
                </Stack>
                </StyledRoot>
                
                <Scrollbar>
                    <TableContainer >
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align = 'center'>
                                    Nom de la Gamme
                                </TableCell>
                                
                                <TableCell align = 'center'>
                                    QR(PDF)
                                </TableCell>
                                <TableCell align = 'center'>
                                    QR(Image)
                                </TableCell>
                                <TableCell align = 'center'>
                                    Supprimer
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {companies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            const {name ,id } = row;
                            

                            return (
                            <TableRow hover key={id} tabIndex={-1}  >
                               <TableCell component="th" align="center" scope="row" padding="none">
                                    <Typography variant="subtitle2" noWrap>
                                        {name}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton size="large" color="inherit" onClick={(event)=>{generateQR(id,name)}}>
                                        <Iconify icon={'eva:download-fill'} />
                                    </IconButton>
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton size="large" color="inherit" onClick={(event)=>{generateQRpng(id,name)}}>
                                        <Iconify icon={'eva:download-fill'} />
                                    </IconButton>
                                </TableCell>

                                <TableCell align="center">
                                    <IconButton size="large" color="error" onClick={()=>{
                                        setCurrentID(id)
                                        handleOpenDelete()
                                    }}>
                                        <Iconify icon={'eva:trash-2-outline'} />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                            </TableRow>
                        )}
                        </TableBody>

                        
                    </Table>
                    </TableContainer>
                </Scrollbar>

                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={companies.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Card>

            
        </Container>
        </>
    );







}